<template>
  <div class="AddTvRemoteWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddTvRemoteWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddTvRemoteWidget-main lxn-pos-rel">
      <div class="AddTvRemoteWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.EditWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="AddTvRemoteWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddTvRemoteWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddTvRemoteWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddTvRemoteWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddTvRemoteWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddTvRemoteWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddTvRemoteWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddTvRemoteWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddTvRemoteWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddTvRemoteWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddTvRemoteWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="AddTvRemoteWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Name_text}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="WidgetName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.WidgetName_PlaceHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddAcRemoteWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="AddTvRemoteWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.ChooseHub_text}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
            <div class="AddTvRemoteWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddAcRemoteWidget_text1}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetOutput" :dropDownContex="dropDownTargetOutputs" />
            </div>
            <div class="AddTvRemoteWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTvRemoteWidget_text1}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetRemoteStyle" :dropDownContex="dropDownTargetRemoteStyle" />
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="AddTvRemoteWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.Save_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'


export default {
  name: 'AddTvRemoteWidget',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    DropDown,
  },
  data: function () {
    return {
      WidgetName: '',
      input1State: '',
      activeBoxIndex: 0,
      targetHub: 0,
      outputList: [],
      targetOutput: 0,
      targetRemoteStyle: 0,
    }
  },
  mounted: function () {
    if(this.$store.state.hubs.length == 0){
      alert(this.$store.getters.language.texts.NoInstalledHub_alert);
      this.$router.go(-1);
    }
  },
  watch: {
    targetHub: function (){
      this.targetOutput = 0;
    },
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetOutputs: function () {
      this.outputListCleaner();
      var dropDownTargetOutputs = {
        name: "AddTvRemoteWidget-TargetOutputs",
        title: this.$store.getters.language.texts.ChooseOutput_text,
        selectedIndex: this.targetOutput,
        data: []
      };
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        if(this.$store.state.hubs[this.targetHub].uuid == this.$store.state.nodes[i].hubUUID){
          for(var j = 0; j < this.$store.state.nodes[i].outputs.length; j++){
            if(this.$store.state.nodes[i].outputs[j].type == "IrDevice" && this.$store.state.nodes[i].outputs[j].settings.deviceType == 1){
              this.outputListSetter(
                {
                  node: this.$store.state.nodes[i],
                  output: this.$store.state.nodes[i].outputs[j],
                  outputIndex: j,
                }
              );
              dropDownTargetOutputs.data.push({
                name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].outputs[j].name,
                icon: this.$store.state.nodes[i].outputs[j].icon,
              })
            }
          }
        }
      }
      this.$store.state.hubs.map(x => [...(x.outputs?.internal || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion1 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      }), ...(x.outputs?.expansion2 || []).map(i => {
        return {
          node: {uuid: x.uuid, name: x.name},
          output: {parameterId: i.parameterId, name: i.name, type: "internal"},
        };
      })]).flatMap(x => x).forEach((x, j) => {
        this.outputListSetter(
            {
              node: x.node,
              output: x.output,
              outputIndex: j,
            }
        );
        dropDownTargetOutputs.data.push({
          name: x.node.name + ' > ' + x.output.name,
          icon: "hub",
        })
      });
      return dropDownTargetOutputs;
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "AddTvRemoteWidget-TargetHubs",
        title: this.$store.getters.language.texts.ChooseHub_text,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
    dropDownTargetRemoteStyle: function () {
      var dropDownTargetRemoteStyle = {
        name: "AddTvRemoteWidget-TargetRemoteStyle",
        title: this.$store.getters.language.texts.AddTvRemoteWidget_text1,
        selectedIndex: this.targetRemoteStyle,
        data: [
          {
            name: this.$store.getters.language.texts.AddTvRemoteWidget_remoteStyle1,
            icon: 'remoteController',
          },
          {
            name: this.$store.getters.language.texts.AddTvRemoteWidget_remoteStyle2,
            icon: 'remoteController',
          }
        ]
      };
      return dropDownTargetRemoteStyle;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    outputListCleaner: function () {
      this.outputList = [];
    },
    outputListSetter: function (obj) {
      this.outputList.push(obj);
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.WidgetName_alert);
      }else if(this.outputList.length == 0){
        alert(this.$store.getters.language.texts.NoOutPutForHub_alert);
      }else{
        this.$store.commit('setAppBusy', true);
        var nodeUUIDs = [this.outputList[this.targetOutput].node.uuid];
        var outputIndex = this.outputList[this.targetOutput].outputIndex;
        var hubUUID = this.outputList[this.targetOutput].node.hubUUID;
        this.$store.commit('addWidget', {
          name: this.WidgetName,
          color: this.activeBoxIndex,
          type: "tvRemoteWidget",
          hubUUID: hubUUID,
          nodeUUIDs: nodeUUIDs,
          visible: true,
          path: this.$store.state.activeDashboardFolderId,
          settings: {
            outputIndex: outputIndex,
            remoteStyle: this.targetRemoteStyle,
          }
        });

        this.$store.commit('saveState');
        this.$router.push('/home/dashboard/');
        this.$store.commit('setAppBusy', false);
      }

    },
  }
}
</script>

<style>
  .AddTvRemoteWidget-topCurve-wrapper {
    height: 200px;
  }
  .AddTvRemoteWidget-main {
    z-index: 2;
  }
  .AddTvRemoteWidget-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddTvRemoteWidget-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddTvRemoteWidget-wrapper-colors {
    height: 50px;
  }
  .AddTvRemoteWidget-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddTvRemoteWidget-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddTvRemoteWidget-color.active .AddTvRemoteWidget-selectedColor {
    opacity: 1;
  }
  .AddTvRemoteWidget-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddTvRemoteWidget-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddTvRemoteWidget-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .AddTvRemoteWidget-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddTvRemoteWidget-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddTvRemoteWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddTvRemoteWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddTvRemoteWidget-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .AddTvRemoteWidget-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
  .AddTvRemoteWidget-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .AddTvRemoteWidget-wrapper-commands:first-child {
    margin-top: 0;
  }
  .AddTvRemoteWidget-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .AddSingleSwitchWidget-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
